<mat-card class="a2" *ngIf="allowTransactions">
  <mat-card-header>
    <mat-card-title>CARRO DE PAGO</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-mini-loader
      *ngIf="loading || loadingTokuEnabledRuts"
    ></app-mini-loader>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <ng-template matStepperIcon="edit">
        <mat-icon>done</mat-icon>
      </ng-template>
      <mat-step *ngIf="!dataAPagar">
        <p class="b1">Selecciona las propuestas que deseas pagar</p>
        <ng-template matStepLabel>Selecciona tus propuestas</ng-template>

        <mat-accordion *ngFor="let item of propuestas; index as i">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-checkbox
                  [(ngModel)]="item.Selected"
                  (click)="$event.stopPropagation()"
                  >&nbsp;</mat-checkbox
                >
                {{ item.NombreProducto }}
              </mat-panel-title>
              <mat-panel-description>
                {{ item.Monto | currency: 'CLP' }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-grid-list cols="4" rowHeight="100px" gutterSize="0">
              <mat-grid-tile class="col1">
                <div class="a1">
                  <span class="label">Número de Propuesta</span>
                  <span class="value">{{ item.CodigoIdentificacion }}</span>
                </div>
              </mat-grid-tile>
              <mat-grid-tile class="col2">
                <div class="a1">
                  <span class="label">Nombre del Contratante</span>
                  <span class="value">{{ item.NombreContratante }}</span>
                </div>
              </mat-grid-tile>
              <mat-grid-tile class="col3">
                <div class="a1">
                  <span class="label">RUT</span>
                  <span class="value">{{ item.Rut }}</span>
                </div>
              </mat-grid-tile>
              <mat-grid-tile class="col4">
                <div class="a1">
                  <span class="label">Nombre Vendedor</span>
                  <span class="value">{{ item.NombreVendedor }}</span>
                </div>
              </mat-grid-tile>
            </mat-grid-list>
            <div class="info">
              <mat-icon>info</mat-icon>
              <span
                >Usted prodrá realizar el pago hasta el día 22-02-2019. De lo
                contrario su solicitud de seguro quedará sin efecto.</span
              >
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <!-- <mat-accordion [displayMode]="'flat'">
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-checkbox (click)="$event.stopPropagation()"
                  >&nbsp;</mat-checkbox
                >
                ACCIDENTES PERSONALES 2009
              </mat-panel-title>
              <mat-panel-description>
                $4.009
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-grid-list cols="4" rowHeight="100px" gutterSize="0">
              <mat-grid-tile class="col1">
                <div class="a1">
                  <span class="label">Número de Propuesta</span>
                            <span class="value">22222252964</span>
                        </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col2">
                            <div class="a1">
                                <span class="label">Nombre del Contratante</span>
                                <span class="value">Jessica Beatriz Pizarro Aguilera</span>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col3">
                            <div class="a1">
                                <span class="label">RUT</span>
                                <span class="value">13567987-2</span>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col4">
                            <div class="a1">
                                <span class="label">Nombre Vendedor</span>
                                <span class="value">Mitzy Alejandra Bustos Fernandez</span>
                            </div>
                        </mat-grid-tile>
                        </mat-grid-list>
                        <div class="info">
                            <mat-icon>info</mat-icon>
                            <span>Usted prodrá realizar el pago hasta el día 22-02-2019. De lo
                contrario su solicitud de seguro quedará sin efecto.</span
              >
            </div>
          </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion [displayMode]="'flat'">
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-checkbox (click)="$event.stopPropagation()"
                  >&nbsp;</mat-checkbox
                >
                ACCIDENTES PERSONALES 2015
              </mat-panel-title>
              <mat-panel-description>
                $4.009
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-grid-list cols="4" rowHeight="100px" gutterSize="0">
              <mat-grid-tile class="col1">
                <div class="a1">
                  <span class="label">Número de Propuesta</span>
                            <span class="value">22222252964</span>
                        </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col2">
                            <div class="a1">
                                <span class="label">Nombre del Contratante</span>
                                <span class="value">Jessica Beatriz Pizarro Aguilera</span>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col3">
                            <div class="a1">
                                <span class="label">RUT</span>
                                <span class="value">13567987-2</span>
                            </div>
                        </mat-grid-tile>
                        <mat-grid-tile class="col4">
                            <div class="a1">
                                <span class="label">Nombre Vendedor</span>
                                <span class="value">Mitzy Alejandra Bustos Fernandez</span>
                            </div>
                        </mat-grid-tile>
                        </mat-grid-list>
                        <div class="info">
                            <mat-icon>info</mat-icon>
                            <span>Usted prodrá realizar el pago hasta el día 22-02-2019. De lo
                contrario su solicitud de seguro quedará sin efecto.</span
              >
            </div>
          </mat-expansion-panel>
        </mat-accordion> -->

        <div class="step-buttons" *ngIf="getItemsForPay().length > 0">
          <button mat-flat-button matStepperNext>Siguiente</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Carro de pago</ng-template>
        <p class="b1">Resumen de tus propuestas a pagar</p>

        <app-table
          *ngIf="
            displayedColumns &&
            displayedColumns.length > 0 &&
            getItemsForPay().length > 0
          "
          [displayedColumns]="displayedColumns"
          [theme]="1"
          [hasFooter]="true"
          [datasource]="getItemsForPay()"
          (iconClick$)="onIconClick($event)"
        ></app-table>

        <div
          class="container-message-warning"
          *ngIf="getItemsForPay().length === 0"
        >
          <svg-icon
            src="../../../assets/icons/exclamation-message-error.svg"
            [svgStyle]="{
              'width.rem': 1.5,
              'height.rem': 1.5,
              position: 'relative',
              'top.rem': 0.15
            }"
          ></svg-icon>
          <label>
            Tu carro de pago está vacío. Vuelve a agregar primas.
          </label>
        </div>

        <!-- <table mat-table [dataSource]="data" class="table">
          <ng-container matColumnDef="Numero">
            <th mat-header-cell *matHeaderCellDef>Nº</th>
            <td mat-cell *matCellDef="let element">1002222252964</td>
            <td mat-footer-cell *matFooterCellDef>TOTAL</td>
          </ng-container>

          <ng-container matColumnDef="Propuesta">
            <th mat-header-cell *matHeaderCellDef>Propuesta</th>
            <td mat-cell *matCellDef="let element">
              Accidentes Personales 2009
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="Vencimiento">
            <th mat-header-cell *matHeaderCellDef>Vencimiento</th>
            <td mat-cell *matCellDef="let element">07-02-2019</td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="Monto">
            <th mat-header-cell *matHeaderCellDef>Monto</th>
            <td mat-cell *matCellDef="let element">$4.009</td>
            <td mat-footer-cell *matFooterCellDef>$4.009</td>
          </ng-container>

          <ng-container matColumnDef="AccionEliminar">
            <th mat-header-cell *matHeaderCellDef>Eliminar</th>
            <td mat-cell *matCellDef="let element">
              <svg-icon src="../../../assets/icons/close_btn.svg"></svg-icon>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>
          <tr mat-footer-row *matFooterRowDef="columns"></tr>
        </table> -->

        <div class="step-buttons">
          <button mat-stroked-button (click)="onBackPago()">Volver</button>
          <button
            mat-flat-button
            matStepperNext
            *ngIf="getItemsForPay().length > 0"
            [disabled]="loadingTokuEnabledRuts"
          >
            Siguiente
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Forma de pago</ng-template>
        <p class="b1">Selecciona la forma de pago que más te acomode</p>
        <mat-card class="medios-pago">
          <div class="container-forma-pago">
            <label *ngIf="isTokuEnabled" class="payment-option">
              <input type="radio" [(ngModel)]="formaPago" value="toku" />
              <img
                class="medio-pago"
                [ngClass]="{
                  seleccionado: formaPago === 'toku',
                  'no-seleccionado': formaPago !== 'toku'
                }"
                src="../../../../assets/img/toku.png"
              />
            </label>
            <label class="payment-option">
              <input type="radio" [(ngModel)]="formaPago" value="webpay" />
              <img
                class="medio-pago"
                [ngClass]="{
                  seleccionado: formaPago === 'webpay',
                  'no-seleccionado': formaPago !== 'webpay'
                }"
                src="../../../../assets/img/webpay.jpg"
              />
            </label>
          </div>
        </mat-card>
        <div class="step-buttons">
          <button mat-stroked-button matStepperPrevious>Volver</button>
          <button [disabled]="!formaPago" mat-flat-button (click)="pagar()">
            Pagar
          </button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Finalizado</ng-template>
        <iframe
          #iframeWebpay
          style="border: 0 !important; height: 50rem"
          width="100%"
          height="100%"
          src=""
          name="iframeWP"
        ></iframe>
        <form #formWebPay method="POST" action="" name="formWP" target="_blank">
          <input type="hidden" id="token_ws" name="token_ws" />

          <input type="hidden" id="xml" name="xml" />
        </form>
        <button (click)="onCloseWebpay()" mat-stroked-button matStepperPrevious>
          Cerrar carro y volver
        </button>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-card-content>
</mat-card>
